import { render, staticRenderFns } from "./g-video-copyright.vue?vue&type=template&id=36cacdab&scoped=true&"
import script from "./g-video-copyright.vue?vue&type=script&lang=ts&"
export * from "./g-video-copyright.vue?vue&type=script&lang=ts&"
import style0 from "./g-video-copyright.vue?vue&type=style&index=0&id=36cacdab&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cacdab",
  null
  
)

export default component.exports